import { OrderDataFusionSummary } from "../../../dispatch/src/OrderDataFusionSummary";
import { StopProgress } from "../../../dispatch/src/StopProgress";
import { CityState, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBillingOverview extends Layout {
    billingDistanceDangerImage: Image;
    citystateCustomer: CityState;
    horizontalspacer1: HorizontalSpacer;
    imageComments: Image;
    imageDatafusionCustomer: Image;
    imageNotifications: Image;
    imagePrinted: Image;
    imageQuickBill: Image;
    imageRebill: Image;
    imageSplitBill: Image;
    imageSummaryInvoice: Image;
    imageYSplit: Image;
    label4: Label;
    labelAddress1: Label;
    labelAddress2: Label;
    labelBillDistanceUm: Label;
    labelBillingDistance: Label;
    labelBillingDistanceCaption: Label;
    labelBridgeCustomer: Label;
    labelContactEmail: Label;
    labelContactPhone: Label;
    labelEquipmentTypeId: Label;
    labelO: Label;
    labelOrdersorderValue: Label;
    labelReferenceNumbers: Label;
    labelTempDelim: Label;
    labelTempMax: Label;
    labelTempMin: Label;
    labelTemperatureRange: Label;
    labelTotalChargeswithTaxes: Label;
    labelTrackingRequired: Label;
    labelTrailerType: Label;
    layoutOrderDataFusionSummary: OrderDataFusionSummary;
    layoutStopProgress: StopProgress;
    panel15: Panel;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    panel6: Panel;
    panel8: Panel;
    panelBillingDistance: Panel;
    panelCommodity: Panel;
    panelDataFusion: Panel;
    panelDelivered: Panel;
    panelIcons: Panel;
    panelOrderInfo: Panel;
    panelStopInfo: Panel;
    panelTax: Panel;
    panelTempRange: Panel;
    sourceBilling: DataSource;
    sourceBillingComments: DataSource;
    sourceCalculateOverridePay: DataSource;
    sourceCustomer: DataSource;
    sourceDataFusionOrderSummary: DataSource;
    sourceDistanceAlert: DataSource;
    sourceOrders: DataSource;
    textboxBillingDate: Textbox;
    textboxBillingUser: Textbox;
    textboxBlnum: Textbox;
    textboxBolDate: Textbox;
    textboxCommodity: Textbox;
    textboxConsigneeRefNo: Textbox;
    textboxContactName: Textbox;
    textboxExcisetaxTotal: Textbox;
    textboxFreightCharge: Textbox;
    textboxInvoiceNbr: Textbox;
    textboxInvoiceRecvDate: Textbox;
    textboxName: Textbox;
    textboxOtherCharge: Textbox;
    textboxPieces: Textbox;
    textboxSalespersonId: Textbox;
    textboxShipmentId: Textbox;
    textboxTotalCharge: Textbox;
    textboxTotalchargeAndExcisetax: Textbox;
    textboxTransferDate: Textbox;
    textboxWeight: Textbox;
}
